export const LastUpdated = '04 avril 2026';
